<template>
    <div class="selectedMonth">
        <div class="kpi" v-for="value in values" :key="value.label">
            <span class="label">
                <span v-if="value.color" class="color" :style="{backgroundColor: value.color}"></span>
                {{value.label}}
            </span>
            <span v-if="isUnset(value.value)" class="value">{{props.unsetValue}}</span>
            <span v-else-if="typeof value.value === 'string'" class="value">{{value.value}}</span>
            <CountingNumber v-else class="value" :to="value.value" :formatter="value.formatter" />
        </div>
    </div>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {Money} from "@/graphql/generated/graphql";
import CountingNumber from '@/components/CountingNumber.vue';
import {isUnset} from "@/helper/isset";

type ApexChartValueLineValue = {
    label: string;
    value: number|Money|string|null|undefined;
    formatter?: (value: number|Money) => number|string;
    color?: string;
}

// props
const props = defineProps({
    values: {
        type: Array as PropType<ApexChartValueLineValue[]>,
        required: true,
    },
    unsetValue: {
        type: String,
        default: '-',
    }
});
</script>

<style lang="scss" scoped>
.selectedMonth {
    display: flex;
    .kpi {
        display: inline-block;

        .value, .label {
            display: inline-block;
            width: 100%;
        }

        .label {
            color: var(--ion-color-grey);
            display: inline-flex;
            align-items: center;
            gap: 0.25em;
        }
        .color {
            width: 0.2em;
            height: 0.8em;
            display: inline-block;
            flex: 0 0 0.2em;
        }
        .value {
            font-weight: bold;
        }
    }
}
</style>
